/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable func-names */
import * as yup from 'yup';
import { AnyObject, Message, Maybe } from 'yup/lib/types';
import { EHelperText } from './validation';

declare module 'yup' {
    interface ArraySchema<T> {
        requiredChecked(key?: string, message?: Message): ArraySchema<T>;
    }
    interface StringSchema<
        TType extends Maybe<string> = string | undefined,
        TContext extends AnyObject = AnyObject,
        TOut extends TType = TType
        > extends yup.BaseSchema<TType, TContext, TOut> {
        notEmpty(): StringSchema<TType, TContext>;
    }
    interface StringSchema<
    TType extends Maybe<string> = string | undefined,
    TContext extends AnyObject = AnyObject,
    TOut extends TType = TType
    > extends yup.BaseSchema<TType, TContext, TOut> {
    notAllowSpace(): StringSchema<TType, TContext>;
}
}

yup.addMethod<yup.ArraySchema<any>>(yup.array, "requiredChecked", function (key = 'checked', errorMessage = 'at less one checked') {
    return this.test(`test-minimium-checked`, errorMessage, function (value: any) {
        const { path, createError } = this;

        return (
            value.some((item: any) => item[key]) || this.createError({ path, message: errorMessage })
        );
    });
});

yup.addMethod<yup.StringSchema>(yup.string, "notEmpty", function (errorMessage = EHelperText.PATTERN) {
    return this.test(`test-not-empty`, errorMessage, function (value: any) {
        const { path, createError } = this;

        return value && value.trim().length > 0
    });
});

yup.addMethod<yup.StringSchema>(yup.string, "notAllowSpace", function (errorMessage = EHelperText.PATTERN) {
    return this.test(`test-not-allow-space`, errorMessage, function (value: any) {
        const { path, createError } = this;

        return value && value.replace(/ /g,'').length === value.length
    });
});
